<svg id="b" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g id="c" data-name="Titles">
    <g>
      <rect width="64" height="64" fill="none"/>
      <g>
        <path class="filled" d="M21.942,48.939l.05-5.759h-5.439c-2.595,0-4.699-2.104-4.699-4.699V20.831c0-2.596,2.104-4.7,4.7-4.7h30.895c2.595,0,4.699,2.104,4.699,4.699v17.649c0,2.596-2.104,4.7-4.7,4.7h-10.39l-10.25,8.135c-1.976,1.568-4.887,.146-4.865-2.376Zm-5.39-28.808c-.386,0-.699,.314-.699,.7v17.648c0,.386,.313,.7,.699,.7h9.475l-.066,7.701,9.702-7.701h11.785c.386,0,.699-.314,.699-.7V20.831c0-.386-.313-.7-.699-.7H16.552Z" fill="currentColor"/>
        <g>
          <rect class="filled" x="20.705" y="27.806" width="4.643" height="4" rx="1" ry="1" fill="currentColor"/>
          <rect class="filled" x="29.678" y="27.806" width="4.643" height="4" rx="1" ry="1" fill="currentColor"/>
          <rect class="filled" x="38.652" y="27.806" width="4.643" height="4" rx="1" ry="1" fill="currentColor"/>
        </g>
      </g>
    </g>
  </g>
</svg>